import React from 'react';
import { flag } from '../../../utils/utils';
// import { countryCode } from '../../../data/data-country-code';
import  styles from  './country-flag.module.scss'; // import CSS file with animation styles

const  CountryFlag= ({country, code, link}) => {

   const linkOnMobile = link? (<a href={link} target="_blank" rel="noreferrer" className={styles.externalLink}>{country}*</a>) : '';

    return (
      <span className={styles.countryFlag}>
          <img src={flag(code)} alt={country} /> 
          <span className={`${styles.countryName} ${link ? styles.hideMobile : ''}`}>{country}</span>
          {linkOnMobile}
      </span>
    )

}

export default CountryFlag;
